import { useState, useEffect } from "react";

/**
 * P5: debounce fast-changing values (e.g. search) to reduce filter/recompute work on large lists.
 */
export function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
